import { useCallback, useEffect, useMemo, useRef } from 'react'
import { Icon } from '@iconify/react'

// antd
import { Row, Input } from 'antd'

// components
import Button from '../../../../components/button/button'

// task components
import AssigneeSelectPopover from '../../../taskRefactored/components/assigneeSelector'

import styles from '../../../taskRefactored/tasks.module.css'

import './index.css'

const CreateTaskCardSprint = ({
    createTask,
    setCreateTask,
    filteredAssignees,
    createTaskFromBoard,
    cancelCreateTask,
}) => {
    const cardRef = useRef(null)
    const popoverRef = useRef(null)
    const inputRef = useRef(null)
    const inputValueRef = useRef(createTask?.title || '')

    const handleInputChange = (e) => {
        const newTitle = e.target.value.trimStart()
        inputValueRef.current = newTitle

        // Update the title in the card
        setCreateTask({ title: newTitle })
    }

    const handleKeyDown = (e) => {
        if (
            (e.key === 'Enter' || e.keyCode === 13) &&
            inputValueRef.current.length > 0
        ) {
            e.preventDefault()
            setCreateTask((prev) => ({
                ...prev,
                title: inputValueRef.current,
            }))
            createTaskFromBoard(inputValueRef.current)
        }
    }

    const selectedAssignee = useMemo(() => {
        return filteredAssignees.find(
            (data) => data?.value === createTask?.assigneeId
        )
    }, [filteredAssignees, createTask?.assigneeId])

    const handleAssigneeChange = (value) => {
        setCreateTask({ assigneeId: value }) // or whatever key you use, like `assignedTo`
    }

    return (
        <div
            className={[styles.card, styles.createTaskCard].join(' ')}
            ref={cardRef}
            style={{
                opacity: createTask?.loading ? 0.5 : 1,
                pointerEvents: createTask?.loading ? 'none' : 'auto',
                position: 'relative',
                marginBottom: 0,
                minHeight: '92px',
                height: '92px',
            }}
        >
            {createTask?.loading && (
                <div className={styles.loaderCreateTask}></div>
            )}
            <Input.TextArea
                className={styles.createTaskInput}
                placeholder="What needs to be done?"
                autoFocus
                defaultValue={createTask?.title}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown} // changed from onKeyUp
                ref={inputRef}
                autoSize={{ minRows: 1, maxRows: 10 }}
                style={{
                    resize: 'none',
                    overflowY: 'scroll',
                    scrollbarColor: '#888 #fff',
                    scrollbarWidth: 'thin',
                }}
            />
            <Row align="middle" justify="space-between">
                <AssigneeSelectPopover
                    assigneeList={filteredAssignees}
                    value={selectedAssignee}
                    onChange={handleAssigneeChange}
                    placement="bottom"
                    assigneeEmptyShow={false}
                    searchable
                    ref={popoverRef}
                />
                <Row
                    align="middle"
                    style={{
                        columnGap: '5px',
                    }}
                >
                    <Button
                        props={{
                            disabled: createTask?.title?.length === 0,
                            buttonType: 'text',
                            styles: {
                                width: 'auto',
                            },
                            className: 'createTaskSprintBoard',
                            onClick: () => {
                                if (createTask?.title?.length > 0) {
                                    createTaskFromBoard(createTask?.title)
                                }
                            },
                            icon: (
                                <div className="createTaskSprintBtn">
                                    <Icon
                                        icon="uil:enter"
                                        height={15}
                                        width={15}
                                    />
                                </div>
                            ),
                        }}
                    />
                    <Button
                        props={{
                            buttonType: 'text',
                            styles: {
                                width: 'auto',
                            },
                            className: 'createTaskSprintBoard',
                            onClick: () => {
                                cancelCreateTask()
                            },
                            icon: (
                                <div className="createTaskSprintBtn">
                                    <Icon
                                        icon="maki:cross"
                                        height={10}
                                        width={10}
                                    />
                                </div>
                            ),
                        }}
                    />
                </Row>
            </Row>
        </div>
    )
}

export default CreateTaskCardSprint
